module.exports = __webpack_public_path__ + "img/ins-name.c12d04bb.svg";